import editStudyDetailsReducer from './reducers';
export { default as editStudyDetailsOperations } from './operations';
export { default as editStudyDetailsTypes } from './types';
export default editStudyDetailsReducer;
